export default __webpack_public_path__ + "static/media/gallery19.b086dc64.webp";